import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface DiffComment {
  comment: string
  filePath: string
  startLineNumber: number
  endLineNumber: number
  fileContent: string
}

export interface DiffReview {
  generalDiffComment: string
  diffComments: DiffComment[]
}

type SliceState = {
  reviews: Record<string, DiffReview>
}

const initialState: SliceState = {
  reviews: {}
}

export const editorSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setGeneralDiffComment(
      state,
      action: PayloadAction<{ uuid: string; generalDiffComment: string }>
    ) {
      const { uuid, generalDiffComment } = action.payload
      const review = state.reviews[uuid] || {}
      review.generalDiffComment = generalDiffComment
      state.reviews[uuid] = review
    },
    upsertDiffComment(state, action: PayloadAction<{ uuid: string; comment: DiffComment }>) {
      const { uuid, comment } = action.payload
      const review = state.reviews[uuid] || {}
      const diffComments = review.diffComments || []
      const existingComment = diffComments.find(
        c => c.filePath === comment.filePath && c.startLineNumber === comment.startLineNumber
      )
      if (existingComment) {
        existingComment.comment = comment.comment
      } else {
        diffComments.push(comment)
      }
      review.diffComments = diffComments
      state.reviews[uuid] = review
    }
  }
})

export const { setGeneralDiffComment, upsertDiffComment } = editorSlice.actions

export default editorSlice.reducer
